module.exports = __webpack_public_path__ + "static/media/fruits_7.0a474b61.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_7.csv
// module id = 723
// module chunks = 0